"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denseScaleMap = void 0;
exports.getDenseAvatarPixelSize = getDenseAvatarPixelSize;
exports.getNormalAvatarPixelSize = getNormalAvatarPixelSize;
exports.useAvatarSize = exports.normalScaleMap = void 0;
var _useScaleConditional = require("../scale/useScaleConditional");
const denseScaleMap = {
  xxxl: 48,
  xxl: 44,
  xl: 36,
  l: 24,
  m: 20,
  s: 16
};
exports.denseScaleMap = denseScaleMap;
const normalScaleMap = {
  xxxl: 56,
  xxl: 48,
  xl: 40,
  l: 32,
  m: 24,
  s: 16
};
exports.normalScaleMap = normalScaleMap;
function getNormalAvatarPixelSize(size) {
  return normalScaleMap[size];
}
function getDenseAvatarPixelSize(size) {
  return denseScaleMap[size];
}
const useAvatarSize = size => {
  const scaleMap = (0, _useScaleConditional.useScaleConditional)({
    dense: denseScaleMap,
    normal: normalScaleMap
  });
  return scaleMap[size];
};
exports.useAvatarSize = useAvatarSize;